import classNames from 'classnames';
import styles from './calendar-charter-icon.module.scss';

export interface CalendarCharterIconProps {
  /** The class name to apply */
  className?: string;
  /** The accessible name of the icon, it is decorative without one */
  label?: string;
  /** The width and height of the icon in pixels */
  size?: number;
}

const CalendarCharterIcon = ({
  className,
  label,
  size = 8,
}: CalendarCharterIconProps) => {
  return (
    <svg
      aria-hidden={label ? undefined : true}
      aria-label={label}
      className={classNames(styles.component, className)}
      fill="none"
      height={size}
      role={label ? 'img' : undefined}
      viewBox="0 0 8 8"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.81549 0.761792C3.90672 0.634958 4.09328 0.634958 4.18451 0.761792L4.76929 1.57476C4.82397 1.65078 4.91855 1.6857 5.00861 1.66312L5.97176 1.42163C6.12202 1.38395 6.26494 1.50559 6.25445 1.66224L6.18724 2.66629C6.18096 2.76018 6.23128 2.8486 6.31458 2.89002L7.20542 3.33301C7.34441 3.40212 7.3768 3.58848 7.26951 3.70164L6.58175 4.42697C6.51744 4.49479 6.49997 4.59533 6.53753 4.68138L6.93924 5.60157C7.00191 5.74513 6.90863 5.90901 6.75472 5.92574L5.76824 6.03295C5.67599 6.04298 5.59889 6.1086 5.57314 6.199L5.29774 7.16583C5.25478 7.31666 5.07947 7.38138 4.95097 7.29385L4.12734 6.73278C4.05032 6.68032 3.94968 6.68032 3.87266 6.73278L3.04903 7.29385C2.92053 7.38138 2.74522 7.31666 2.70225 7.16583L2.42686 6.199C2.40111 6.1086 2.32401 6.04298 2.23176 6.03295L1.24528 5.92574C1.09137 5.90901 0.998093 5.74513 1.06076 5.60157L1.46247 4.68138C1.50003 4.59533 1.48256 4.49479 1.41825 4.42697L0.730494 3.70164C0.623196 3.58848 0.655592 3.40212 0.794575 3.33301L1.68542 2.89002C1.76872 2.8486 1.81904 2.76018 1.81276 2.66629L1.74555 1.66224C1.73506 1.50559 1.87798 1.38395 2.02824 1.42163L2.99138 1.66312C3.08145 1.6857 3.17603 1.65078 3.23071 1.57476L3.81549 0.761792Z"
        fill="currentColor"
      />
    </svg>
  );
};

CalendarCharterIcon.displayName = 'CalendarCharterIcon';

export default CalendarCharterIcon;
